<template>
    <u-badge
      v-if="project.currentStep"
      variant="solid"
      :size="size"
      :ui="{
        base: 'uppercase rounded',
        font: 'font-semibold',
        size: {
          sm: 'text-2xs px-1.5',
          xs: 'text-2xs px-1'
        },
        variant: {
          solid: project.currentStep.badgeColor
        }
      }"
    >
      <!--todo: icon prop when we migrate to nuxt ui 2.20.0-->
      <u-icon
        :name="project.currentStep.badgeIcon"
        class="text-white mr-1 h-3.5 w-3.5" />
      <span class="tracking-wider whitespace-nowrap">{{project.currentStep.label}}</span>
    </u-badge>
</template>

<script setup>
  const props = defineProps({
    project: Object,
    size: {
      type: String,
      default: 'sm'
    }
  });
</script>
